var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.1132 8.4725C2.52935 7.88865 2.52935 6.93947 3.1132 6.35563L4.47892 4.9899L3.8302 4.34119L2.46448 5.70691C1.52213 6.64926 1.52213 8.17887 2.46448 9.12122C3.40683 10.0636 4.93644 10.0636 5.87878 9.12122L7.24451 7.75549L6.59579 7.10677L5.23007 8.4725C4.64622 9.05634 3.69704 9.05634 3.1132 8.4725ZM4.85449 7.41406L7.58594 4.68262L6.90308 3.99976L4.17163 6.7312L4.85449 7.41406ZM5.87878 2.2926L4.51306 3.65833L5.16178 4.30704L6.5275 2.94132C7.11135 2.35747 8.06053 2.35747 8.64437 2.94132C9.22822 3.52517 9.22822 4.47434 8.64437 5.05819L7.27865 6.42391L7.92737 7.07263L9.29309 5.70691C10.2354 4.76456 10.2354 3.23495 9.29309 2.2926C8.35074 1.35025 6.82113 1.35025 5.87878 2.2926Z","fill":"#fffef8"}));
}

Link.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none"};

module.exports = Link;

Link.default = Link;
